import React, { useCallback, memo } from 'react';
import { useHistory } from 'react-router-dom';

import { Flex, Layout, Box } from 'Components/Base';
import Breadcrumb from 'Components/Breadcrumb';
import BreadcrumbLayout from 'Components/BreadcrumbLayout';
import LSPUserData from 'Domains/LSPUserData';
import StudentModuleProgress from 'Containers/StudentModuleProgress';
import StudentPracQuizProgress from 'Containers/StudentPracQuizProgress';
import StudentRIASEC from 'Containers/StudentRIASEC';
import TeacherProfileBox from 'Containers/TeacherProfileBox';
import TabContent from 'Components/TabContent';
import { withAuth } from 'Libs/Auth';

const BreadcrumbComponent = memo(function BreadcrumbComponent() {
  const items = [
    {
      key: 'dashboard',
      title: 'Dashboard',
      path: '/student/dashboard',
    },
  ];
  return <Breadcrumb items={items} variant={'dark'} />;
});

const StudentDashboardPage = props => {
  const history = useHistory();
  const {
    auth: {
      myProfile: { id: userId },
    },
  } = props;
  return (
    <BreadcrumbLayout
      breadcrumbComponent={useCallback(
        () => (
          <BreadcrumbComponent />
        ),
        [],
      )}
    >
      <TabContent
        content={
          <Flex flexDirection={'column'}>
            <StudentModuleProgress userId={userId} />
            <StudentPracQuizProgress
              userId={userId}
              onViewAll={() => history.push('/student/dashboard/pracquiz')}
            />
            <StudentRIASEC userId={userId} />
          </Flex>
        }
        sidebar={
          <LSPUserData userId={userId}>
            {({ loading, error, data }) => {
              if (loading) return null;
              if (error) return null;
              const {
                foProfile: { teacherId },
              } = data;
              return <TeacherProfileBox userId={teacherId} />;
            }}
          </LSPUserData>
        }
      />
    </BreadcrumbLayout>
  );
};

export default memo(withAuth(StudentDashboardPage));
